import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import axios from 'axios';
import { keyBy, get } from 'lodash';
import App from './App';
import Layout from './containers/Layout/Layout';
import * as serviceWorker from './serviceWorker';
import i18n from './config/translations';
import createStore from './data/store';

function getSubdomain() {
  return window.location.host && window.location.host.split('.')[0];
}
const sub = getSubdomain()
const appendedValue = true ? "-server": ""
axios.defaults.baseURL = window.location.hostname.includes('agudot')
  ? `https://${sub}-crm${appendedValue}.agudot.co.il`
  : '';
axios.defaults.withCredentials = true;

i18n('he');
function renderApp() {
  ReactDOM.render(
    <Provider store={createStore()}>
      <Layout />
    </Provider>,
    document.getElementById('root')
  );
}
axios.get('/configuration/v1?client="eliran"').then((res) => {
  const config = get(res, 'data.configuration.config');
  window.WEBO_CONFIG = keyBy(get(res, 'data.envConfig', []), 'key');
  if (!config) {
    return null;
  }
  localStorage.setItem('config', JSON.parse(config));
  renderApp();
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
